import { SolutionType } from "../store/realTimeUpdates";
import { GanttTabBarTab } from "../types/ganttChart";

export const getSolutionType = (tab: GanttTabBarTab): SolutionType => {
  const typeMap: Record<GanttTabBarTab, SolutionType> = {
    Original: "NexusSolution",
    Optimised: "PondooSolution",
    Custom: "CustomSolution",
    Edit: "CustomSolution", //Edit is a placeholder tab that redirects to Custom.
  };
  return typeMap[tab];
};
